/**
 * Identifiant unique généré côté client.
 *
 * C'est la pièce centrale de l'idempotence : cet uuid accompagne l'événement
 * jusqu'en base, où le serveur applique `ON CONFLICT (id) DO NOTHING`.
 * Un lot renvoyé dix fois n'insère jamais deux fois la même ligne.
 */
export function uuid(): string {
  const c = globalThis.crypto

  if (c && typeof c.randomUUID === 'function') {
    return c.randomUUID()
  }

  // Repli pour les contextes non sécurisés (http:// sur IP locale, vieux
  // WebView Android) où randomUUID est absent mais getRandomValues présent.
  if (c && typeof c.getRandomValues === 'function') {
    const o = c.getRandomValues(new Uint8Array(16))
    o[6] = ((o[6] as number) & 0x0f) | 0x40 // version 4
    o[8] = ((o[8] as number) & 0x3f) | 0x80 // variante RFC 4122
    const hex = [...o].map((n) => n.toString(16).padStart(2, '0')).join('')
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
  }

  throw new Error("Aucune source d'aléa disponible : impossible de garantir l'idempotence.")
}
